// src/services/pagesettingServices.ts
import api from "../lib/api.ts";

interface PageSettingParams {
    page: string;
    lang: string;
}

export const getPageSettings = async (params: PageSettingParams) => {
  const response = await api.get(`/pagesettings/${params.page}?lang=${params.lang}`);
  if (typeof response.data === 'string') {
    try {
      response.data = JSON.parse(response.data);
      
    } 
    catch {
      // failed to parse JSON string
    }
  }

  return response.data;
};